/*
 * Copyright 2021 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { FieldValidation } from '@rjsf/utils';
import { KubernetesValidatorFunctions } from '@backstage/catalog-model';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

export const uniqueEntityNamePickerValidation = async (
  value: string,
  validation: FieldValidation,
  context: any,
) => {
  if (!KubernetesValidatorFunctions.isValidObjectName(value)) {
    validation.addError(
      'Must start and end with an alphanumeric character, and contain only alphanumeric characters, hyphens, underscores, and periods. Maximum length is 63 characters.',
    );
  }

  const catalogApi = context.apiHolder.get(catalogApiRef);

  if (catalogApi) {
    try {
      const entities = await catalogApi.getEntities({
        filter: { 'metadata.name': value },
        limit: 1,
      });

      if (entities.items.length === 1) {
        validation.addError(`This name is already taken in the catalog.`);
      }
    } catch (error) {
      validation.addError('Error validating entity name uniqueness.');
    }
  } else {
    validation.addError('Catalog API is not available.');
  }
};
